// kbpgp requires sodium, which will not resolve as it is not an actualy
// dependency.  Webpack warns about this.  Reoslve by exporting an empty
// object for sodium.
// https://github.com/keybase/node-nacl/issues/5

module.exports = {}
